import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess as SEOSegmentationSearchResultsSuccessType } from '@/__generated__/getSearchResults';

interface Base {
  '@type': string;
}

interface Context {
  '@vocab': string;
}

interface CaregiverItemListElement extends Base {
  name: string;
  url: string;
  position: number;
}

interface JobItemListElement extends Base {
  url: string;
  position: number;
}

interface LdJson extends Base {
  '@context': Context;
  numberOfItems: number;
  itemListElement: CaregiverItemListElement[] | JobItemListElement[];
}

interface SearchResultsSchemaProps {
  results:
    | SEOSegmentationSearchResultsSuccessType['caregiverSearchResults']
    | SEOSegmentationSearchResultsSuccessType['jobSearchResults'];
  totalNumberOfResults: number;
  startIndex: number;
}

const ItemListSchema = ({
  results,
  totalNumberOfResults,
  startIndex,
}: SearchResultsSchemaProps) => {
  const createListItems = () => {
    return results.map(
      (searchResult, index: number): CaregiverItemListElement | JobItemListElement => {
        if ('caregiver' in searchResult) {
          const caregiverProfile = searchResult.caregiver.profiles?.commonCaregiverProfile;
          return {
            '@type': 'WebPage',
            name: `${searchResult.caregiver.member.displayName} ${caregiverProfile?.bio.title}`,
            url: `${searchResult.profileURL}`,
            position: startIndex + index + 1,
          };
        }
        return {
          '@type': 'ListItem',
          url: searchResult.jobDetailURL ?? '',
          position: startIndex + index + 1,
        };
      }
    );
  };

  const itemList: LdJson = {
    '@context': {
      '@vocab': 'http://schema.org/',
    },
    '@type': 'ItemList',
    numberOfItems: totalNumberOfResults,
    itemListElement: createListItems(),
  };

  return (
    <script
      data-testid="itemListSchema"
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(itemList) }}
    />
  );
};

export default ItemListSchema;
